import React from "react";
import { TrendingUp, Maximize2, Wallet, Timer, Percent } from "lucide-react";

const ICONS = [Wallet, Maximize2, TrendingUp, Timer];

export default function Financials({ t }) {
  return (
    <section id="financials" className="relative py-24 md:py-32" data-testid="financials-section">
      {/* subtle backdrop pattern */}
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-amber-600/5 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full bg-red-900/5 blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-16">
          <div className="text-amber-500 text-xs uppercase tracking-[0.3em] mb-4">{t.eyebrow}</div>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-stone-50 leading-tight">{t.title}</h2>
          <p className="mt-5 text-stone-300 text-base md:text-lg leading-relaxed">{t.sub}</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {t.cards.map((c, i) => {
            const Icon = ICONS[i];
            return (
              <div key={i} className="heritage-card p-7 relative" data-testid={`financial-card-${i}`}>
                <div className="flex items-center justify-between mb-6">
                  <span className="text-[10px] uppercase tracking-[0.25em] text-stone-500">0{i + 1}</span>
                  <span className="text-amber-500"><Icon size={20} /></span>
                </div>
                <div className="text-xs uppercase tracking-[0.2em] text-stone-400 mb-2">{c.label}</div>
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="font-serif text-4xl md:text-5xl text-stone-50 leading-none whitespace-nowrap">{c.value}</span>
                  {c.unit && <span className="text-stone-400 text-sm">{c.unit}</span>}
                </div>
                <p className="mt-5 text-stone-400 text-sm leading-relaxed">{c.note}</p>
              </div>
            );
          })}
        </div>

        {/* Royalty highlight */}
        <div className="mt-8 heritage-card overflow-hidden relative">
          <div className="grid md:grid-cols-12 items-center">
            <div className="md:col-span-3 p-8 md:p-10 bg-gradient-to-br from-amber-600 to-amber-700 text-stone-950 relative">
              <Percent size={28} strokeWidth={2.5} className="opacity-60 mb-3" />
              <div className="font-serif text-5xl md:text-6xl leading-none">{t.royalty}</div>
            </div>
            <div className="md:col-span-9 p-8 md:p-10">
              <p className="text-stone-200 text-base md:text-lg leading-relaxed">{t.royalty_text}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
